export { InboxState } from '../../common/boards/boardConstants';

export const INBOX_WIDTH = 38;

// time in milliseconds
export const INBOX_CLOSE_BUFFER_TIME = 200;
